export default __webpack_public_path__ + "static/media/incumbent_label.d57477f4.svg";